import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { queries } from 'RestAPIs/rapini';

import { Box, styled, TextField } from '@mui/material';

import { VirtualizedAutocomplete } from 'components/shared';

import MappingFunctionsGrid from './MappingFunctionsGrid';
import MappingQualificationsGrid from './MappingQualificationsGrid';

const StyledRegionalPool = styled(Box)``;

export default function RegionalPool() {
  const { t } = useTranslation('common');
  const [regionalPoolTenantName, setRegionalPoolTenantName] = useState<
    string | null
  >(null);

  const { data } = queries.useGetRegionalPools({ retry: false });
  const options =
    data?.map(({ tenantName, displayName }) => ({
      id: tenantName,
      name: displayName
    })) ?? [];

  return (
    <StyledRegionalPool>
      <Box mb={4} width="25%">
        <VirtualizedAutocomplete
          options={options}
          getOptionLabel={(option) => {
            if (typeof option === 'string') {
              return option;
            }
            return option.name as string;
          }}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          renderInput={(params) => (
            <TextField {...params} label={t('selectRegionalPool')} />
          )}
          onChange={(e, value: any) => {
            setRegionalPoolTenantName(value?.id ?? null);
          }}
        />
      </Box>
      <Box display="flex" gap={2}>
        <Box flex={1}>
          <MappingFunctionsGrid
            regionalPoolTenantName={regionalPoolTenantName}
          />
        </Box>
        <Box flex={1}>
          <MappingQualificationsGrid
            regionalPoolTenantName={regionalPoolTenantName}
          />
        </Box>
      </Box>
    </StyledRegionalPool>
  );
}
